import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import HamburgerButton from '../hamburger-button'
import NavigationItem from './navigation-item'
import NavigationUser from './navigation-user'
import LinkButton from '../../elements/link'
import NavbarListElement from './navbar-list-element'

export default function Navbar({
  pageLogo,
  homeUrl,
  showNavigation,
  disableHide,
  navigationItems,
  profilePath,
  authenticityToken,
  userName,
  userDetailsActive,
  uploadPath,
  position,
  context,
  envName,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const [isToolbarOpen, setIsToolbarOpen] = useState(true)
  const [toolbar, setToolbar] = useState(null)

  const handleMenuOpen = isOpen => {
    setIsOpen(isOpen)
  }

  const handleToolbarToggle = () => {
    setIsToolbarOpen(!isToolbarOpen)
  }

  useEffect(() => {
    setToolbar(document.querySelector('#toolbar-placeholder'))
  }, [])

  useEffect(() => {
    if (!toolbar) return

    if (isToolbarOpen) {
      toolbar.classList.remove('tw-hidden')
    } else {
      toolbar.classList.add('tw-hidden')
    }
  }, [isToolbarOpen, toolbar])

  return (
    <>
      <div
        className={`
          ${
            context === 'toolbar' ? 'tw-py-3 tw-w-toolbar' : 'tw-w-full tw-py-3'
          }
          ${isToolbarOpen ? position : 'tw-hidden'}
          tw-shadow-navbar tw-mb-5 tw-z-30 tw-bg-header-background tw-text-header-text-color`}>
        <div
          className={`
      ${
        context !== 'toolbar'
          ? 'md:tw-flex md:tw-justify-between tw-px-9'
          : 'tw-pl-5 tw-pr-3'
      }
      tw-text-header`}>
          <div className="tw-flex tw-justify-between tw-items-center">
            <a href={homeUrl} className="tw-relative tw-z-10" aria-label="home">
              <img
                src={pageLogo}
                alt="logo"
                className="tw-max-w-full tw-h-9 tw-object-contain"
              />
            </a>
            {envName && <span className="tw-mt-2 tw-ml-4">{envName}</span>}
            {showNavigation && (
              <HamburgerButton
                thin={context === 'toolbar'}
                className={`${context !== 'toolbar' ? 'md:tw-hidden' : ''}`}
                onClick={handleMenuOpen}
              />
            )}
          </div>

          {showNavigation && (
            <nav
              className={`
            ${isOpen ? 'tw-h-nav tw-opacity-100' : 'tw-h-0 tw-opacity-0'}
            ${
              context !== 'toolbar'
                ? 'md:tw-h-auto md:tw-opacity-100 md:tw-flex md:tw-items-center '
                : ''
            }
            tw-overflow-hidden 
            tw-ease-in 
            tw-duration-200`}>
              <ul
                className={`
            ${
              context !== 'toolbar'
                ? 'md:tw-flex md:tw-items-center md:tw-my-0 md:tw-space-x-7'
                : ''
            }
            tw-list-none tw-m-0 tw-my-4 tw-p-0 tw-py-1 tw-custom-uppercase `}>
                {Object.keys(navigationItems).map(key => (
                  <NavigationItem
                    context={context}
                    active={navigationItems[key].active}
                    title={key}
                    type={navigationItems[key].type}
                    action={navigationItems[key].action}
                    key={key}
                    badge={navigationItems[key].badge}
                  />
                ))}
                <NavigationUser
                  context={context}
                  authenticityToken={authenticityToken}
                  userFullName={userName}
                  active={userDetailsActive}
                  profilePath={profilePath}
                />
                {uploadPath && (
                  <NavbarListElement
                    className="tw-flex-shrink-0"
                    toolbar={context === 'toolbar'}>
                    <LinkButton
                      action="primary"
                      size="large"
                      className="tw-w-auto"
                      href={uploadPath}>
                      Upload Images
                    </LinkButton>
                  </NavbarListElement>
                )}
              </ul>
            </nav>
          )}
        </div>
      </div>
      {context === 'toolbar' && !disableHide && (
        <button
          className={`
        ${isToolbarOpen ? 'tw-left-toolbar' : 'tw-left-0'}
        tw-custom-button-reset tw-absolute tw-top-0 tw-bg-header-background tw-z-10`}
          onClick={handleToolbarToggle}>
          <i
            className={`${
              isToolbarOpen ? 'fas fa-caret-left' : 'fas fa-caret-right'
            } tw-py-6 tw-px-2`}></i>
        </button>
      )}
    </>
  )
}

Navbar.defaultProps = {
  position: 'tw-relative',
}

Navbar.propTypes = {
  pageLogo: PropTypes.string,
  homeUrl: PropTypes.string,
  showNavigation: PropTypes.bool,
  disableHide: PropTypes.bool,
  navigationItems: PropTypes.object,
  profilePath: PropTypes.string,
  authenticityToken: PropTypes.string,
  userName: PropTypes.string,
  userDetailsActive: PropTypes.bool,
  uploadPath: PropTypes.string,
  position: PropTypes.string,
  context: PropTypes.string,
  envName: PropTypes.string,
}
